import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { avatarInitial, relativeTime } from "./planUtils";
const DEFAULT_COLOR = "bg-slate-400";
function actorLabel(event) {
    const name = event.actorName?.trim();
    return name && name.length > 0 ? name : "מישהו";
}
function target(event) {
    return event.itemText?.trim() || "";
}
// One short Hebrew sentence per event. Packing copy uses נארז.
function sentence(event) {
    const who = actorLabel(event);
    const what = target(event);
    const section = event.sectionTitle?.trim() || what;
    const count = event.count ?? 0;
    switch (event.action) {
        case "item_added":
            return `${who} הוסיף: ${what}`;
        case "items_added_batch":
            return `${who} הוסיף ${count} פריטים ל${section}`;
        case "item_deleted":
            return `${who} מחק: ${what}`;
        case "item_text_changed":
            return `${who} ערך פריט: ${what}`;
        case "item_quantity_changed":
            return `${who} שינה כמות: ${what}`;
        case "item_assigned":
            return `${who} שייך: ${what}`;
        case "item_unassigned":
            return `${who} הסיר שיוך: ${what}`;
        case "item_checked":
            return `${who} סימן שנארז: ${what}`;
        case "items_checked_batch":
            return `${who} סימן ${count} פריטים כנארזו`;
        case "item_unchecked":
            return `${who} ביטל סימון אריזה: ${what}`;
        case "item_buy_there_enabled":
            return `${who} סימן לקנות שם: ${what}`;
        case "item_buy_there_disabled":
            return `${who} ביטל לקנות שם: ${what}`;
        case "item_note_added":
            return `${who} הוסיף הערה: ${what}`;
        case "section_added":
            return `${who} הוסיף קטגוריה: ${what}`;
        case "section_renamed":
            return `${who} שינה שם קטגוריה`;
        case "subsection_added":
            return `${who} הוסיף תת־קטגוריה: ${what}`;
        case "subsection_renamed":
            return `${who} שינה שם תת־קטגוריה`;
        default:
            return `${who} עדכן את התכנון`;
    }
}
// Subtle leading icon by action type.
function icon(event) {
    switch (event.action) {
        case "item_added":
        case "items_added_batch":
        case "section_added":
        case "subsection_added":
            return "➕";
        case "item_deleted":
            return "🗑️";
        case "item_checked":
        case "items_checked_batch":
            return "✅";
        case "item_unchecked":
            return "↩️";
        case "item_assigned":
            return "🙋";
        case "item_unassigned":
            return "➖";
        case "item_quantity_changed":
            return "🔢";
        case "item_buy_there_enabled":
        case "item_buy_there_disabled":
            return "🛒";
        case "item_note_added":
            return "📝";
        default:
            return "✏️";
    }
}
export function RecentActivityCard({ events, colorMap, limit = 5 }) {
    const visible = events.slice(0, limit);
    return (_jsxs("section", { className: "rounded-2xl border border-slate-100 bg-white p-4 shadow-sm", dir: "rtl", children: [_jsx("h3", { className: "mb-3 text-sm font-semibold text-slate-800", children: "\u05DE\u05D4 \u05D4\u05E9\u05EA\u05E0\u05D4 \u05DC\u05D0\u05D7\u05E8\u05D5\u05E0\u05D4" }), visible.length > 0 ? (_jsx("ul", { className: "space-y-2", children: visible.map((event) => {
                    const who = actorLabel(event);
                    const color = colorMap[who] ?? DEFAULT_COLOR;
                    return (_jsxs("li", { className: "flex items-center gap-3 rounded-2xl bg-slate-50 px-3 py-2", children: [_jsx("span", { className: `flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white ${color}`, "aria-hidden": true, children: avatarInitial(who) }), _jsxs("div", { className: "min-w-0 flex-1", children: [_jsxs("p", { className: "truncate text-sm text-slate-700", children: [_jsx("span", { className: "ml-1", "aria-hidden": true, children: icon(event) }), sentence(event)] }), _jsx("p", { className: "text-[11px] text-slate-400", children: relativeTime(event.createdAt) })] })] }, event.id));
                }) })) : (_jsx("p", { className: "rounded-2xl bg-slate-50 px-3 py-4 text-center text-sm text-slate-400", children: "\u05E2\u05D5\u05D3 \u05D0\u05D9\u05DF \u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05DC\u05D4\u05E6\u05D2\u05D4" }))] }));
}
